/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Injectable } from '@angular/core';
import { UserService, AccessListRole } from './user.service';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { XdaStringsService } from './xda-strings.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router,
    private xdaStringsService: XdaStringsService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const route = state.url.substring(1);
    const res = this.canActivateRoute(route);
    if (!res && !this.userService.isLoggedOn()) {
      if (route !== '') {
        this.userService.redirectToHome();
      }
      return false;
    }
    if (!res) {
      this.navigateHome();
    }
    return res;
  }

  canActivateRoute(route: string): boolean {
    switch (route) {
      case 'workflows':
      case 'translate':
      case 'terms':
        return (
          this.userService.isLoggedOn() &&
          (this.userService.user?.isSubscriptionUser || false)
        );
      case 'access-list':
        return (
          this.userService.isLoggedOn() &&
          (this.userService.user?.accessListRole === AccessListRole.Owner ||
            this.userService.user?.accessListRole === AccessListRole.Manager)
        );
      case 'manage-subscription':
        return (
          this.userService.isLoggedOn() &&
          this.userService.user?.accessListRole === AccessListRole.Owner
        );
      case 'active-documents':
        return this.userService.isLoggedOn() && this.userService.isAdvancedPlan;
      case 'categories':
        return this.userService.isLoggedOn() && this.userService.isAdvancedPlan;
      case '':
      default:
        return (
          (this.userService.isLoggedOn() &&
            !this.userService.user?.isSubscriptionUser) ||
          !this.userService.isLoggedOn()
        );
    }
  }

  navigateHome() {
    if (this.userService.user?.isSubscriptionUser) {
      if (location.pathname !== '/manage-subscription') {
        this.userService.editAGAccountIfRequired();
        if (this.xdaStringsService.strings['APPNAME'] === 'Translates') {
          this.router.navigate(['/translate']);
        } else {
          this.router.navigate(['/workflows']);
        }
      }
    } else {
      this.userService.redirectToHome();
    }
  }
}
